module.exports = __webpack_public_path__ + "img/time.ff7593b2.svg";